<template>
  <v-card class="pa-2 gray10 fill-height">
    <div class="plate-tables" v-if="currentCoin">
      <v-btn icon @click="updateTableMaxRow(0)">
        <img
          alt=""
          v-if="tab === 0"
          src="../../../assets/image/plate_all_active.png"
        />
        <img alt="" v-else src="../../../assets/image/plate_all.png" />
      </v-btn>
      <v-btn icon @click="updateTableMaxRow(1)">
        <img
          alt=""
          v-if="tab === 1"
          src="../../../assets/image/plate_green_active.png"
        />
        <img alt="" v-else src="../../../assets/image/plate_green.png" />
      </v-btn>
      <v-btn icon @click="updateTableMaxRow(2)">
        <img
          alt=""
          v-if="tab === 2"
          src="../../../assets/image/plate_red_active.png"
        />
        <img alt="" v-else src="../../../assets/image/plate_red.png" />
      </v-btn>

      <div>
        <v-data-table
          dense
          v-if="tab !== 1"
          class="custom-price-data-table ask mb-2"
          no-data-text=""
          :headers="headers"
          :items="tab === 0 ? askItems : fullAskItems"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;"
          @click:row="updateTradeForms"
        >
          <template v-slot:header.price="{}">
            <span class="font-Regular-12">
              {{ $t("exchange.price") }}({{
                currentCoin.symbol.split("/")[1].toUpperCase()
              }})
            </span>
          </template>
          <template v-slot:header.symbol="{}">
            <span class="font-Regular-12">
              {{ $t("exchange.price") }}({{
                currentCoin.symbol.split("/")[1].toUpperCase()
              }})
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <div class="font-Regular-12 text-center red--text">
              <div
                v-if="tab === 0"
                :style="
                  `background-color: red; opacity: 0.1; position: absolute; width: ${(
                    item.totalAmount / askItems.at(0).totalAmount
                  ).toFixed(4) * 100}%;height: 20px; padding: 4px 0;`
                "
              ></div>
              <div
                v-else
                :style="
                  `background-color: red; opacity: 0.1; position: absolute; width: ${(
                    item.totalAmount / fullAskItems.at(0).totalAmount
                  ).toFixed(4) * 100}%;height: 20px; padding: 4px 0;`
                "
              ></div>
              {{ $thousandMask(item.price, currentCoin.frontBaseCoinScale) }}
            </div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div class="font-Regular-12 text-center">
              {{ $thousandMask(item.amount, currentCoin.frontCoinScale) }}
            </div>
          </template>
          <template v-slot:item.totalAmount="{ item }">
            <div class="font-Regular-12 text-center">
              {{ $thousandMask(item.totalAmount, currentCoin.frontCoinScale) }}
            </div>
          </template>
          <template v-slot:body.prepend>
            <template v-if="tab === 0">
              <tr v-for="i in tableMaxRow - askItems.length" :key="i">
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="i in tableMaxRow - fullAskItems.length" :key="i">
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
              </tr>
            </template>
          </template>
        </v-data-table>
        <div class="text-center py-3 d-flex align-center justify-center">
          <span :class="currentCoin.chg > 0 ? 'green--text' : 'red--text'">
            {{
              $thousandMask(currentCoin.close, currentCoin.frontBaseCoinScale)
            }}
          </span>
          <v-icon
            v-if="currentCoin.chg > 0"
            size="18"
            clr="#4CAF50"
            class="transform-arrow-top"
          >
            $vuetify.CustomIcons.arrowCustomIcons.arrow
          </v-icon>
          <v-icon
            v-else-if="currentCoin.chg < 0"
            size="18"
            clr="#F44336"
            class="transform-arrow-down"
          >
            $vuetify.CustomIcons.arrowCustomIcons.arrow
          </v-icon>
          <!--                    <span v-if="currentCoin.chg > 0" class="green&#45;&#45;text">↑</span>-->
          <!--                    <span v-else-if="currentCoin.chg < 0" class="red&#45;&#45;text">↓</span>-->
        </div>
        <v-data-table
          dense
          v-if="tab !== 2"
          no-data-text=""
          class="custom-price-data-table bid mb-2"
          :headers="headers"
          :items="tab === 0 ? bidItems : fullBidItems"
          :hide-default-header="tab !== 1"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;"
          @click:row="updateTradeForms"
        >
          <template v-slot:header.price="{}">
            <span class="font-Regular-12">
              {{ $t("exchange.price") }}({{
                currentCoin.symbol.split("/")[1].toUpperCase()
              }})
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <div class="font-Regular-12 text-center green--text">
              <div
                v-if="tab === 0"
                :style="
                  `background-color: green; opacity: 0.1; position: absolute; width: ${(
                    item.totalAmount / bidItems.at(-1).totalAmount
                  ).toFixed(4) * 100}%;height: 20px; padding: 4px 0;`
                "
              ></div>
              <div
                v-else
                :style="
                  `background-color: green; opacity: 0.1; position: absolute; width: ${(
                    item.totalAmount / fullBidItems.at(-1).totalAmount
                  ).toFixed(4) * 100}%;height: 20px; padding: 4px 0;`
                "
              ></div>
              {{
                $thousandMask(item.price, currentCoin.frontBaseCoinScale) || "-"
              }}
            </div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div class="font-Regular-12 text-center">
              {{
                $thousandMask(item.amount, currentCoin.frontCoinScale) || "-"
              }}
            </div>
          </template>
          <template v-slot:item.totalAmount="{ item }">
            <div class="font-Regular-12 text-center">
              {{
                $thousandMask(item.totalAmount, currentCoin.frontCoinScale) ||
                  "-"
              }}
            </div>
          </template>
          <template v-slot:body.append>
            <template v-if="tab === 0">
              <tr v-for="i in tableMaxRow - bidItems.length" :key="i">
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="i in tableMaxRow - fullBidItems.length" :key="i">
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
                <td class="font-Regular-12 text-center">-</td>
              </tr>
            </template>
          </template>
        </v-data-table>
        <v-data-table
          dense
          class="custom-price-data-table trade mb-2"
          :headers="tradeHeaders"
          :items="tradeItems"
          hide-default-footer
          disable-pagination
          fixed-header
          height="300px"
          ref="table"
          style="max-height: 300px;"
          @click:row="updateTradeForms"
        >
          <template v-slot:header.price="{}">
            <span class="font-Regular-12">
              {{ $t("exchange.price") }}({{
                currentCoin.symbol.split("/")[1].toUpperCase()
              }})
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <div
              class="font-Regular-12 text-center"
              :class="item.direction === 'BUY' ? 'green--text' : 'red--text'"
            >
              {{
                $thousandMask(item.price, currentCoin.frontBaseCoinScale) || "-"
              }}
            </div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div class="font-Regular-12 text-center">
              {{
                $thousandMask(item.amount, currentCoin.frontCoinScale) || "-"
              }}
            </div>
          </template>
          <template v-slot:item.time="{ item }">
            <div class="font-Regular-12 text-center">
              {{ formatTimes(item.time) }}
            </div>
          </template>
          <template v-slot:no-data>
            <p style="height: 225px" class="mt-5">{{ $t("common.nodata") }}</p>
          </template>
        </v-data-table>
      </div>
    </div>
    <div v-else>{{ $t("common.nodata") }}</div>
  </v-card>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { MarketMarketService } from "@/services";
import dayjs from "@/utiles/dayjs";
import SockJS from "sockjs-client";
import Stomp from "stompjs";

export default {
  name: "plateTables",
  mixins: [$thousandMask],
  data() {
    return {
      tab: 0,
      tableMaxRow: 10,
      headers: [
        {
          text: this.$t("exchange.price"),
          value: "price",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("exchange.total"),
          value: "totalAmount",
          align: "center",
          sortable: false
        }
      ],
      tradeHeaders: [
        {
          text: this.$t("exchange.price"),
          value: "price",
          align: "center",
          width: 70,
          sortable: false
        },
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          width: 70,
          sortable: false
        },
        {
          text: this.$t("exchange.time"),
          value: "time",
          align: "center",
          width: 120,
          sortable: false
        }
      ],
      askItems: [],
      bidItems: [],
      fullAskItems: [],
      fullBidItems: [],
      tradeItems: [],
      plateStompClient: null,
      tradeStompClient: null,
      plateSubscription: null,
      tradeSubscription: null
    };
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    })
  },
  watch: {
    "currentCoin.symbol": {
      handler(newVal) {
        this.getPlate(newVal);
        this.getTrade(newVal);
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setCurrentCoin: types.marketExchange.actions.SET_CURRENT_COIN
    }),
    updateTableMaxRow(value) {
      this.tab = value;
      this.tab === 0 ? (this.tableMaxRow = 10) : (this.tableMaxRow = 20);
    },
    formatTimes(time) {
      return dayjs(time).format("ss : mm : HH");
    },
    updateTradeForms(itemValue) {
      this.$emit("updateTradeForms", itemValue);
    },
    calculateTotalAmount(items) {
      items.map((item, index) => {
        if (index === 0) {
          item.totalAmount = item.amount;
        } else {
          item.totalAmount = items[index - 1].totalAmount + item.amount;
        }
      });
      return items;
    },
    getPlate(item) {
      MarketMarketService.getPlateMini({ symbol: item.replace("_", "/") }).then(
        res => {
          this.fullAskItems = res.data.ask.items.slice(0, 20).reverse();
          this.fullBidItems = res.data.bid.items.slice(0, 20);
          this.askItems = this.calculateTotalAmount(res.data.ask.items)
            .slice(0, 10)
            .reverse();
          this.bidItems = this.calculateTotalAmount(res.data.bid.items).slice(
            0,
            10
          );
          this.startPlateSocket(item.replace("_", "/"));
        }
      );
    },
    getTrade(item) {
      let payload = {
        symbol: item.replace("_", "/"),
        size: 20
      };
      MarketMarketService.getLatestTrades(payload).then(response => {
        this.tradeItems = response.data;
        this.startTradeSocket(item.replace("_", "/"));
      });
    },
    startPlateSocket(item) {
      if (this.plateSubscription) {
        this.plateSubscription.unsubscribe();
      }
      if (this.plateStompClient) {
        this.plateStompClient.disconnect();
      }
      // let stompClient = null;
      let socket = new SockJS(
        `${process.env.VUE_APP_BASE_MARKET}/market/market-ws`
        // `https://market-api.excoino.com/market/market-ws`
      );
      this.plateStompClient = Stomp.over(socket);
      this.plateStompClient.debug = false;
      this.plateStompClient.connect({}, () => {
        this.plateSubscription = this.plateStompClient.subscribe(
          `/topic/market/trade-plate/${item}`,
          msg => {
            let resp = JSON.parse(msg.body);
            if (resp.direction === "BUY") {
              this.bidItems = this.calculateTotalAmount(resp.items).slice(
                0,
                10
              );
              this.fullBidItems = this.calculateTotalAmount(resp.items).slice(
                0,
                20
              );
            } else {
              this.askItems = this.calculateTotalAmount(resp.items)
                .slice(0, 10)
                .reverse();
              this.fullAskItems = this.calculateTotalAmount(resp.items)
                .slice(0, 20)
                .reverse();
            }
          }
        );
      });
    },
    startTradeSocket(item) {
      if (this.tradeSubscription) {
        this.tradeSubscription.unsubscribe();
      }
      if (this.tradeStompClient) {
        this.tradeStompClient.disconnect();
      }
      let socket = new SockJS(
        `${process.env.VUE_APP_BASE_MARKET}/market/market-ws`
        // `https://market-api.excoino.com/market/market-ws`
      );
      this.tradeStompClient = Stomp.over(socket);
      this.tradeStompClient.debug = false;
      this.tradeStompClient.connect({}, () => {
        this.tradeSubscription = this.tradeStompClient.subscribe(
          `/topic/market/trade/${item}`,
          msg => {
            let resp = JSON.parse(msg.body);
            if (resp.length) {
              this.trade.rows = [...resp, ...this.trade.rows].slice(0, 30);
            }
          }
        );
      });
    }
  },
  beforeDestroy() {
    // Clean up subscriptions and connections
    if (this.plateSubscription) {
      this.plateSubscription.unsubscribe();
    }
    if (this.plateStompClient) {
      this.plateStompClient.disconnect();
    }
    if (this.tradeSubscription) {
      this.tradeSubscription.unsubscribe();
    }
    if (this.tradeStompClient) {
      this.tradeStompClient.disconnect();
    }
  }
};
</script>
<style lang="scss">
.custom-price-data-table {
  .v-data-table__wrapper {
    table {
      thead {
        tr {
          height: 20px;
        }
      }

      tbody {
        tr {
          position: relative;
          height: 20px !important;

          td {
            padding: 2px 0;
            height: auto !important;
          }
        }
      }
    }
  }
}
</style>
